import moment                       from "moment";

/* Helpers */
import {consultInformationC, consultByCodePostal} from '../helpers/queries';
import {getBase64FromUrl}                         from "../helpers/functions";

export const getInfomationOnboarding = async  (uuid, view, creditid, setUiidState, closeModal, windoMessage, documentsProspect, setDocumentsProspect, inftProspect, setInftProspect, setOpColonias, windowLoad) =>  {

    consultInformationC(String(uuid), creditid).then(function (response) {
        if(response.toString() === "error"){
            closeModal();
            windoMessage('No se pudo cargar correctamente la información');
        }else{
            
            setUiidState(uuid);

            if(response.filesd.code === 200 || response.filesd.code === 1003){
                
                if(response.filesd.response.ineAnverso !=  null){
                    getBase64FromUrl(response.filesd.response.ineAnverso).then((img) => {
                        documentsProspect[view === "" ? 'ifefrenteup' : 'ifefrente']   = img;
                        setDocumentsProspect((prev) => {
                            return { ...prev, ...documentsProspect }
                        });
                    });
                    //documentsProspect[view === "" ? 'ifefrenteup' : 'ifefrente']   = response.filesd.response.ineAnverso;
                }
    
                if(response.filesd.response.ineReverso != null){
                    getBase64FromUrl(response.filesd.response.ineReverso).then((img) => {
                        documentsProspect[view === "" ? 'ifedetrasup' : 'ifedetras']   = img;
                        setDocumentsProspect((prev) => {
                            return { ...prev, ...documentsProspect }
                        });
                    });
                    //documentsProspect[view === "" ? 'ifedetrasup' : 'ifedetras']   = response.filesd.response.ineReverso;
                }
    
                if(response.filesd.response.selfie != null){
                    getBase64FromUrl(response.filesd.response.selfie).then((img) => {
                        documentsProspect[view === "" ? 'selfiebase64up' : view === "selfie" ? 'selfiebase64' : 'selfiebase64up'] = img; 
                        setDocumentsProspect((prev) => {
                            return { ...prev, ...documentsProspect }
                        });
                    });
                    //documentsProspect[view === "" ? 'selfiebase64up' : view === "selfie" ? 'selfiebase64' : 'selfiebase64up'] = response.filesd.response.selfie; 
                }
                
                if(response.filesd.response.comprobante != null){
                    getBase64FromUrl(response.filesd.response.comprobante).then((img) => {
                        documentsProspect[view === "" ? 'comprobbase64up' : view === "imgdoc" ? 'comprobbase64' : 'comprobbase64up']  = img; 
                        setDocumentsProspect((prev) => {
                            return { ...prev, ...documentsProspect }
                        });
                    });
                    //documentsProspect[view === "" ? 'comprobbase64up' : view === "imgdoc" ? 'comprobbase64' : 'comprobbase64up']  = response.filesd.response.comprobante;
                }
    
                /*setDocumentsProspect((prev) => {
                    return { ...prev, ...documentsProspect }
                });*/

                if(response.infd.code === 200){

                    if(view === "" ){
                        closeModal();
                    }else{
                        if( (documentsProspect.ifefrente != "" && documentsProspect.ifedetras != "" ) || (documentsProspect.ifefrenteu != "" && documentsProspect.ifedetrasup != "" )){
                            closeModal();
                        }else if( (documentsProspect.selfiebase64 != ""  ) || (documentsProspect.selfiebase64up != "" )){
                            closeModal();
                        }else if( (documentsProspect.comprobbase64 != ""  ) || (documentsProspect.comprobbase64up != "" )){
                            closeModal();
                        }else{
                            closeModal();
                        }
                    }
                    
                    inftProspect['curp']              =  response.infd.response.personalInfo.curp      ? response.infd.response.personalInfo.curp      : "";
                    inftProspect['curpextra']         =  response.infd.response.personalInfo.curp      ? response.infd.response.personalInfo.curp      : "";
                    inftProspect['name']              =  response.infd.response.personalInfo.nombre    != null  || response.infd.response.personalInfo.nombre    != "null" ? response.infd.response.personalInfo.nombre    : "";
                    inftProspect['firstname']         =  response.infd.response.personalInfo.apellidoP != null  || response.infd.response.personalInfo.apellidoP != "null" ? response.infd.response.personalInfo.apellidoP : "";
                    inftProspect['isfirstname']       =  response.infd.response.personalInfo.apellidoP === null || response.infd.response.personalInfo.apellidoP === ''    ? true : false;
                    inftProspect['secondname']        =  response.infd.response.personalInfo.apellidoM != null  || response.infd.response.personalInfo.apellidoM != "null" ? response.infd.response.personalInfo.apellidoM : "";
                    inftProspect['issecondname']      =  response.infd.response.personalInfo.apellidoM === null || response.infd.response.personalInfo.apellidoM === ''    ? true : false;
                    inftProspect['datebirday']        =  response.infd.response.personalInfo.fechaN    ? moment(response.infd.response.personalInfo.fechaN,"DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY") : "";
                    //inftProspect['sexo']              =  response.infd.response.personalInfo.genero != null  || response.infd.response.personalInfo.genero != "null" ? response.infd.response.personalInfo.genero : "M" ;
                    inftProspect['maritalstatus']     =  response.infd.response.personalInfo.estadoCivil != null  || response.infd.response.personalInfo.estadoCivil != "null" ? response.infd.response.personalInfo.estadoCivil : "soltero" ;
                    inftProspect['rfc']               =  response.infd.response.personalInfo.rfc;
                    inftProspect['claveelector']      =  response.infd.response.personalInfo.claveElector;
                    inftProspect['numeroine']         =  response.infd.response.personalInfo.numeroINE;
                
                    inftProspect['municipyBirday']    =  response.infd.response.personalInfo.ciudadNac != null  || response.infd.response.personalInfo.ciudadNac != "null" ? response.infd.response.personalInfo.ciudadNac   : "";
                    inftProspect['stateBirday']       =  response.infd.response.personalInfo.estadoNac != null  || response.infd.response.personalInfo.estadoNac != "null" ? response.infd.response.personalInfo.estadoNac   : "";
                    inftProspect['countryBirday']     =  response.infd.response.personalInfo.paisNac   != null  || response.infd.response.personalInfo.paisNac != "null" ? response.infd.response.personalInfo.paisNac       : "";

                    inftProspect['street']            =  response.infd.response.adressInfo.calle        != null || response.infd.response.adressInfo.calle        != "null" ? response.infd.response.adressInfo.calle        : "" ;
                    inftProspect['exterior']          =  response.infd.response.adressInfo.numExterior  != null || response.infd.response.adressInfo.numExterior  != "null" ? response.infd.response.adressInfo.numExterior  : "";
                    inftProspect['interior']          =  response.infd.response.adressInfo.numInterno   != null || response.infd.response.adressInfo.numInterno   != "null" ? response.infd.response.adressInfo.numInterno   : "";
                    inftProspect['codepostal']        =  response.infd.response.adressInfo.codigoPostal != null || response.infd.response.adressInfo.codigoPostal != "null" ? response.infd.response.adressInfo.codigoPostal : "";
                    inftProspect['colonia']           =  response.infd.response.adressInfo.colonia      != null || response.infd.response.adressInfo.colonia      != "null" ? response.infd.response.adressInfo.colonia      : "";
                    inftProspect['municipio']         =  response.infd.response.adressInfo.municipio    != null || response.infd.response.adressInfo.municipio    != "null" ? response.infd.response.adressInfo.municipio    : "";
                    inftProspect['estado']            =  response.infd.response.adressInfo.estado       != null || response.infd.response.adressInfo.estado       != "null" ? response.infd.response.adressInfo.estado       : "";
                    inftProspect['country']           =  response.infd.response.adressInfo.pais         != null || response.infd.response.adressInfo.pais         != "null" ? response.infd.response.adressInfo.pais         : "México";
                    
                    inftProspect['cellphone']         =  response.infd.response.contactInfo.telefonoCelular != null || response.infd.response.contactInfo.telefonoCelular != "null" ? response.infd.response.contactInfo.telefonoCelular : "";
                    inftProspect['phonehome']         =  response.infd.response.contactInfo.telefonoCasa    != null || response.infd.response.contactInfo.telefonoCasa    != "null" ? response.infd.response.contactInfo.telefonoCasa    : "";
                    inftProspect['email']             =  response.infd.response.contactInfo.correo          != null || response.infd.response.contactInfo.correo          != "null" ? response.infd.response.contactInfo.correo          : "";
                    
                    windowLoad("Finalizando...");
                    getByCodePostal(response.infd.response.adressInfo.codigoPostal, documentsProspect, view, windowLoad, closeModal, setOpColonias, inftProspect, setInftProspect);

                    setInftProspect((prev) => {
                        return { ...prev, ...inftProspect }
                    });

                }else{
                    closeModal();
                    windoMessage('No se pudo obtener la información Personal del cliente'); 
                }

            }else{
                    closeModal();
                    windoMessage('No se encontraron imagenes para este cliente'); 
            }

        }
    });

}

const getByCodePostal = async (codePostal, documentsProspect, view, windowLoad, closeModal, setOpColonias, inftProspect, setInftProspect) => {

    var neigboorhodArray = []

    consultByCodePostal(String(codePostal).trim()).then(function (responseCP) {

        if(view === ""){
            closeModal();
        }else{
            if( (documentsProspect.ifefrente != "" && documentsProspect.ifedetras != "" ) || (documentsProspect.ifefrenteu != "" && documentsProspect.ifedetrasup != "" )){
                closeModal();
            }else if( (documentsProspect.selfiebase64 != ""  ) || (documentsProspect.selfiebase64up != "" )){
                closeModal();
            }else if( (documentsProspect.comprobbase64 != ""  ) || (documentsProspect.comprobbase64up != "" )){
                closeModal();
            }else{
                closeModal();
            }
        }
        
        if(responseCP === "error"){
            inftProspect['codepostal'] =  String(codePostal).trim();
        }else{
            for (var i = 0; i < responseCP.length; i++) {
                
                neigboorhodArray.push({
                    label: responseCP[i].asentamiento,
                    value: responseCP[i].asentamiento,
                    isDisabled: false,
                });

            }

            setOpColonias(neigboorhodArray);
            
        }

        setInftProspect((prev) => {
            return { ...prev, ...inftProspect }
        });

    });

}